/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-debugger */
/* eslint-disable no-unused-vars */
import * as React from "react";
import { Stepper, Step, StepLabel, useMediaQuery } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import Check from "@mui/icons-material/Check";
import { useState } from "react";
import { useEffect } from "react";

// Cores
const ORANGE_FORTIO = "#FF3100";
const COR_TEXTO = "#012443";
const COR_INATIVA = "#E0E0E0"; // Um cinza neutro para o fundo

// 1. CUSTOMIZANDO O CONECTOR (A LINHA)
const CustomConnector = styled(StepConnector)(({ theme }) => ({
  // Esconde o conector no modo vertical
  [`&.${stepConnectorClasses.vertical}`]: {
    display: "none",
  },
  // Estilos para o modo horizontal
  [`&.${stepConnectorClasses.horizontal}`]: {
    top: 20, // Alinha no meio do nosso Ã­cone customizado (que terÃ¡ 40px)
    left: "calc(-50% + 20px)",
    right: "calc(50% + 20px)",
  },
  // A linha em si
  [`& .${stepConnectorClasses.line}`]: {
    height: 8,
    border: 0,
    backgroundColor: COR_TEXTO,
    borderRadius: 4,
  },
  // Linha ATIVA
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    backgroundColor: COR_TEXTO,
  },
  // Linha COMPLETA
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    backgroundColor: COR_TEXTO,
  },
}));

// 2. CUSTOMIZANDO O ÃCONE (O CÃRCULO)
const CustomStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor: COR_INATIVA,
  zIndex: 1,
  color: COR_TEXTO,
  width: 40,
  height: 40,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "1.1rem",
  fontWeight: "bold",
  boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",

  // Estilo do Ã­cone ATIVO
  ...(ownerState.active && {
    backgroundColor: ORANGE_FORTIO,
    color: "#fff", // Texto do nÃºmero em branco
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  // Estilo do Ã­cone COMPLETO
  ...(ownerState.completed && {
    backgroundColor: ORANGE_FORTIO,
    color: "#fff", // Cor do checkmark
  }),
}));

// FunÃ§Ã£o que decide o que mostrar dentro do Ã­cone
function CustomStepIcon(props) {
  const { active, completed, className, icon } = props;

  return (
    <CustomStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {completed ? <Check sx={{ fontSize: "1.5rem" }} /> : <span>{icon}</span>}
    </CustomStepIconRoot>
  );
}



const steps = [
  "Pendente de contratação", // 1
  "Em Analise de perfil", // 2
  "Em Analise do motorista",
  "Contratado", // 3
  "Em transito", // 4
  "Entregue", // 5
  "Finalizado" // 8
];

// 3. O COMPONENTE FINAL
export default function ModernStepper(propsStatus) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [activeStep, setActiveStep] = useState(propsStatus.propsStatus);
  const [index, setIndex] = useState(propsStatus.propsStatus);
  useEffect(() => {
    setActiveStep(propsStatus.propsStatus);
  }, [propsStatus.propsStatus]);
 

  /**
   * FunÃ§Ã£o chamada quando um passo Ã© clicado.
   * Atualiza o passo ativo e abre o modal para confirmaÃ§Ã£o.
   * @param {number} index - O Ã­ndice do passo clicado.
   */
  /**
   * FunÃ§Ã£o chamada quando o modal Ã© fechado.
   * Recebe um boolean com o resultado do modal (true para confirmar, false para cancelar).
   * Se o resultado for true, atualiza o passo ativo para o passo selecionado.
   * Se o resultado for false, nÃ£o faz nada (mas por enquanto, vamos manter simples).
   * @param {boolean} value - O resultado do modal (true para confirmar, false para cancelar)
   */
  return (
    <>
      <Stepper
        activeStep={activeStep} // 'Em TrÃ¢nsito'
        orientation={isMobile ? "vertical" : "horizontal"}
        // Remove o 'alternativeLabel' para o modo vertical funcionar bem
        alternativeLabel={!isMobile}
        // Conecta nosso conector customizado
        connector={<CustomConnector />}
        // Estiliza os RÃ³tulos (texto)
        sx={{
          // No modo vertical, adiciona um espaÃ§amento
          ...(isMobile && {
            "& .MuiStep-root": {
              marginBottom: "16px",
            },
          }),
          // Estilo do texto (label)
          "& .MuiStepLabel-label": {
            color: COR_TEXTO,
            fontWeight: 500,
            marginTop: "8px",
            // RÃ³tulo ATIVO
            "&.Mui-active": {
              color: COR_TEXTO,
              fontWeight: 700,
            },
            // RÃ³tulo COMPLETO
            "&.Mui-completed": {
              color: COR_TEXTO,
              fontWeight: 500,
            },
          },
        }}
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel
              StepIconComponent={CustomStepIcon}
              
            >
              {label}
            </StepLabel>
          </Step>
        ))}
        </Stepper>
    </>
  );
}





